import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";

export default function InstallCardora() {
  const [prompt, setPrompt] = useState(null);
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const [standalone, setStandalone] = useState(() => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true);
  const [message, setMessage] = useState("");
  useEffect(() => {
    const available = event => { event.preventDefault(); setPrompt(event); };
    const installed = () => { setStandalone(true); setShow(false); setPrompt(null); };
    window.addEventListener("beforeinstallprompt", available);
    window.addEventListener("appinstalled", installed);
    return () => {
      window.removeEventListener("beforeinstallprompt", available);
      window.removeEventListener("appinstalled", installed);
    };
  }, []);
  if (standalone) return null;
  const install = async () => {
    if (!prompt || busy) return;
    setBusy(true);
    try {
      await prompt.prompt();
      await prompt.userChoice;
      setPrompt(null);
      setShow(false);
    } catch {
      setMessage("No se pudo abrir la instalacion. Puedes usar el menu del navegador.");
    } finally { setBusy(false); }
  };
  return <>
    <Button variant="outline-secondary" className="install-cardora-trigger w-100 mt-3" onClick={() => setShow(true)}>
      <i className="bi bi-phone me-2" aria-hidden="true" />Guardar Cardora en mi movil
    </Button>
    <Modal show={show} onHide={() => !busy && setShow(false)} centered>
      <Modal.Header closeButton={!busy}><Modal.Title>Cardora a mano</Modal.Title></Modal.Header>
      <Modal.Body>
        <p>Abre tu coleccion desde la pantalla de inicio.</p>
        {prompt ? <Button className="btn-cardora" disabled={busy} onClick={install}>{busy ? "Abriendo..." : "Instalar Cardora"}</Button>
          : <><p><strong>iPhone:</strong> abre esta web en Safari, pulsa Compartir y selecciona Anadir a pantalla de inicio.</p><p className="mb-0"><strong>Android:</strong> abre el menu del navegador y selecciona Instalar aplicacion o Anadir a pantalla de inicio.</p></>}
        {message && <p role="alert" className="text-danger mt-2">{message}</p>}
      </Modal.Body>
      <Modal.Footer><Button variant="outline-secondary" disabled={busy} onClick={() => setShow(false)}>Cerrar</Button></Modal.Footer>
    </Modal>
  </>;
}
